/* KrakenTheMeta dashboard — Profile: plan and billing (Stripe portal, token packs, the Patreon
 * thank-you claim, receipts), the public profile fields, settings, sign out and account deletion.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;
  var AVATARS = [1, 2, 3, 4, 5, 6].map(function (n) { return "/images/avatar" + n + ".png"; });

  // Links on the public profile are always real web links.
  function normUrl(v) {
    v = String(v || "").trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v;
    return /\s/.test(v) ? "" : "https://" + v.replace(/^\/+/, "");
  }

  KD.routes.profile = function (view) {
    var p = S.profile || {};
    var u = p.assistant_usage || {};
    var used = Number(u.used) || 0;
    var tokens = Number(p.assistant_tokens) || 0;
    var demoUsed = Array.isArray(p.assistant_demo_games) ? p.assistant_demo_games.length : 0;
    var isPatron = ["tier1", "tier2", "tier3"].indexOf(p.patreon || p.patreonTier || "") !== -1;
    var g = D.gens();
    var until = Number(p.assistant_pro_until || 0);

    var plan = S.isPro ? "Kraken Pro · $4.99/mo" : S.isLegacyPatron ? "Early supporter" : "Free";
    var coach = S.isPro
      ? Math.max(0, 750 - used) + " of 750 messages left this month" + (tokens ? " · +" + tokens + " bonus" : "")
      : "Free trial: " + Math.max(0, 3 - demoUsed) + " of 3 coached matches left" + (tokens ? " · " + tokens + " messages banked" : "");
    var builds = g.unlimited ? "Unlimited" : g.left > 0 ? g.left + " free " + KD.plural(g.left, "build") + " left this week" : "Used this week · " + (D.nextResetText(g) || "refills weekly");

    view.innerHTML = '<div data-profile>' +
      '<div class="vhead"><div class="vhead__text"><p class="depth-tag">Your account</p><h2>Profile</h2></div>' +
        '<div class="vhead__actions"><a class="btn btn--ghost" href="' + KD.SITE + "/profile.php?userId=" + encodeURIComponent(S.user.id) + '" target="_blank" rel="noopener">' + KD.icon("external") + "<span>View public profile</span></a></div></div>" +
      '<div class="pgrid">' +
        '<div class="stack" style="gap:16px">' +
          // ---- plan + billing
          '<section class="panel panel--pad">' +
            '<div class="row row--between" style="margin-bottom:6px"><h3 style="margin:0;font:500 21px/1.2 var(--font-display)">Plan &amp; billing</h3>' +
              '<span class="badge ' + (S.isPro ? "badge--glow" : S.isLegacyPatron ? "badge--gold" : "") + '">' + esc(S.isPro ? "Kraken Pro" : S.isLegacyPatron ? "Supporter" : "Free") + "</span></div>" +
            '<div class="plan-rows">' +
              "<div><span>Plan</span><span>" + esc(plan) + "</span></div>" +
              (S.isPro && until ? "<div><span>Access until</span><span>" + esc(new Date(until).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })) + "</span></div>" : "") +
              "<div><span>AI deck builds</span><span>" + esc(builds) + "</span></div>" +
              "<div><span>Arena coach</span><span>" + esc(coach) + "</span></div>" +
            "</div>" +
            '<div class="row row--wrap mt-16">' +
              (S.isPro ? '<button class="btn btn--ghost" type="button" data-billing>' + KD.icon("card") + "<span>Manage billing or cancel</span></button>"
                : '<button class="btn btn--gold" type="button" data-checkout="pro">Upgrade to Kraken Pro · $4.99/mo</button>') +
              (isPatron && !S.isPro ? '<button class="btn btn--ghost" type="button" data-patreon>' + KD.icon("heart") + "<span>Patreon supporter? Claim free Pro</span></button>" : "") +
            "</div>" +
            '<p class="hint mt-16">Extra Arena coach messages without a subscription: <button class="linkbtn" type="button" data-checkout="tok250">250 for $4.99</button> or ' +
              '<button class="linkbtn" type="button" data-checkout="tok750">750 for $9.99</button>. They never expire.</p>' +
            '<h4 class="label mt-24" style="display:block;margin-bottom:4px">Receipts</h4>' +
            '<div class="purchases" data-purchases><div class="skel" style="height:40px;margin-top:8px"></div></div>' +
          "</section>" +
          // ---- account
          '<section class="panel panel--pad">' +
            '<h3 style="margin:0 0 12px;font:500 21px/1.2 var(--font-display)">Account</h3>' +
            '<div class="plan-rows"><div><span>Signed in as</span><span>' + esc(S.user.email || "") + "</span></div></div>" +
            '<div class="row row--wrap mt-16"><button class="btn btn--ghost" type="button" data-signout>' + KD.icon("logout") + "<span>Sign out</span></button></div>" +
          "</section>" +
          '<section class="panel panel--pad danger-zone">' +
            '<h3 style="margin:0 0 8px;font:500 21px/1.2 var(--font-display)">Delete account</h3>' +
            '<p class="hint">Permanently deletes your account and everything in it: decks, collection, Arena history, posts and follows. An active Pro subscription is cancelled right away.</p>' +
            '<button class="btn btn--danger mt-16" type="button" data-delete-account>' + KD.icon("trash") + "<span>Delete my account</span></button>" +
          "</section>" +
        "</div>" +
        // ---- the public profile + settings form
        '<form class="stack" style="gap:16px" data-form novalidate>' +
          '<section class="panel panel--pad">' +
            '<h3 style="margin:0 0 16px;font:500 21px/1.2 var(--font-display)">Public profile</h3>' +
            '<div class="field"><span class="label">Avatar</span><div class="avatars" role="radiogroup" aria-label="Avatar">' +
              AVATARS.map(function (a, i) {
                return '<label><input type="radio" name="avatar" value="' + a + '"' + ((p.avatar || AVATARS[0]) === a ? " checked" : "") + ' aria-label="Avatar ' + (i + 1) + '">' +
                  '<img src="' + esc(KD.avatar(a)) + '" alt="" loading="lazy"></label>';
              }).join("") + "</div></div>" +
            '<label class="field"><span class="label">Display name</span><input class="input" name="name" maxlength="40" autocomplete="nickname" value="' + esc(p.name || p.displayName || "") + '" placeholder="What the community sees"></label>' +
            '<label class="field"><span class="label">Bio</span><textarea class="textarea" name="bio" maxlength="400" placeholder="Favorite formats, pet decks, where you play…">' + esc(p.bio || "") + "</textarea></label>" +
          "</section>" +
          '<section class="panel panel--pad">' +
            '<h3 style="margin:0 0 16px;font:500 21px/1.2 var(--font-display)">Links</h3>' +
            linkField("twitter", "x-logo", "X / Twitter profile URL", p.twitter) +
            linkField("discord", "discord", "Discord invite link", p.discord) +
            linkField("twitch", "twitch", "Twitch channel URL", p.twitch) +
          "</section>" +
          '<section class="panel panel--pad">' +
            '<h3 style="margin:0 0 16px;font:500 21px/1.2 var(--font-display)">Settings</h3>' +
            '<label class="check"><input type="checkbox" name="notify_mentions"' + (p.notify_mentions === false ? "" : " checked") + "><span>Email me when someone tags me in a post or comment</span></label>" +
            '<div class="field mt-16"><span class="label">Your own OpenAI API key (optional)</span>' +
              '<div class="row"><label class="inputwrap" style="flex:1">' + KD.icon("key") +
                '<input class="input" name="openaiKey" type="password" autocomplete="off" spellcheck="false" value="' + esc(p.openaiKey || "") + '" placeholder="sk-…" aria-label="OpenAI API key"></label>' +
                '<button class="iconbtn iconbtn--line" type="button" data-reveal aria-label="Show key" title="Show key">' + KD.icon("eye") + "</button></div>" +
              '<span class="hint">Deck builds use your key instead of the site’s engine. Leave it blank to use ours.</span></div>' +
          "</section>" +
          '<div class="savebar" data-savebar hidden><span>You have unsaved changes</span><div class="row">' +
            '<button class="btn btn--ghost btn--sm" type="button" data-discard>Discard</button>' +
            '<button class="btn btn--lure btn--sm" type="submit" data-save>Save changes</button></div></div>' +
        "</form>" +
      "</div></div>";

    var root = KD.$("[data-profile]", view), form = KD.$("[data-form]", root);

    // ---- unsaved-changes tracking
    function read() {
      var f = form.elements, av = form.querySelector('input[name="avatar"]:checked');
      return {
        name: f.name.value.trim(),
        avatar: av ? av.value : (p.avatar || AVATARS[0]),
        bio: f.bio.value.trim(),
        twitter: f.twitter.value.trim(),
        discord: f.discord.value.trim(),
        twitch: f.twitch.value.trim(),
        openaiKey: f.openaiKey.value.trim(),
        notify_mentions: f.notify_mentions.checked
      };
    }
    var original = read();
    function dirty() { var now = read(); return Object.keys(now).some(function (k) { return now[k] !== original[k]; }); }
    function syncBar() { KD.$("[data-savebar]", root).hidden = !dirty(); }
    form.addEventListener("input", syncBar);
    form.addEventListener("change", syncBar);
    KD.$("[data-discard]", root).addEventListener("click", function () { KD.router(); });
    KD.$("[data-reveal]", root).addEventListener("click", function (e) {
      var i = form.elements.openaiKey, show = i.type === "password";
      i.type = show ? "text" : "password";
      e.currentTarget.setAttribute("aria-label", show ? "Hide key" : "Show key");
    });

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      var data = read();
      if (!data.name) { form.elements.name.focus(); KD.toast("Your display name can't be empty.", "info"); return; }
      data.twitter = normUrl(data.twitter);
      data.discord = normUrl(data.discord);
      data.twitch = normUrl(data.twitch);
      var btn = KD.$("[data-save]", root);
      btn.disabled = true;
      try {
        await D.saveProfile(data);
        original = read();
        ["twitter", "discord", "twitch"].forEach(function (k) { form.elements[k].value = data[k]; original[k] = data[k]; });
        syncBar();
        KD.paintUser();
        KD.toast("Profile saved.", "ok");
        if (data.openaiKey && !/^sk-/.test(data.openaiKey)) KD.toast("That doesn't look like an OpenAI key (they start with sk-). Builds use the site engine until it's fixed.", "info");
      } catch (err) { console.error(err); KD.toast("Couldn't save your profile. Try again.", "err"); }
      btn.disabled = false;
    });

    // ---- billing, Patreon claim, receipts
    var billing = KD.$("[data-billing]", root);
    if (billing) billing.addEventListener("click", async function () {
      billing.disabled = true;
      try {
        var r = await D.callFn("createBillingPortal", {});
        if (r.data.url) { location.href = r.data.url; return; }
        KD.toast(r.data.error || "Couldn't open billing.", "err");
      } catch (e) { KD.toast("Couldn't open billing.", "err"); }
      billing.disabled = false;
    });
    var claim = KD.$("[data-patreon]", root);
    if (claim) claim.addEventListener("click", async function () {
      claim.disabled = true;
      KD.busy("Checking your Patreon membership…");
      try {
        var r = await D.callFn("assistantUpgrade", {});
        KD.idle();
        if (r.data.ok) {
          await D.loadProfile();
          KD.paintUser();
          KD.toast("Thank you for backing the Kraken early. Pro is unlocked.", "ok");
          KD.router();
          return;
        }
        KD.toast(r.data.error || "Couldn't verify your Patreon membership.", "err");
      } catch (e) { KD.idle(); KD.toast("Couldn't verify your Patreon membership.", "err"); }
      claim.disabled = false;
    });
    D.purchases().then(function (list) {
      var box = KD.$("[data-purchases]", root);
      if (!box) return;
      if (!list.length) { box.innerHTML = '<p class="hint" style="padding:10px 0">No purchases yet.</p>'; return; }
      box.innerHTML = list.map(function (d) {
        var when = KD.toDate(d.at);
        var amt = d.amount ? "$" + (d.amount / 100).toFixed(2) : "";
        var meta = [amt, when ? when.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : ""].filter(Boolean).join(" · ");
        return "<div><span>" + esc(d.label || "Purchase") + "</span><span>" + esc(meta) + "</span></div>";
      }).join("");
    }).catch(function () {
      var box = KD.$("[data-purchases]", root);
      if (box) box.innerHTML = '<p class="hint" style="padding:10px 0">Couldn’t load receipts.</p>';
    });

    // ---- sign out + delete
    KD.$("[data-signout]", root).addEventListener("click", async function () {
      if (dirty() && !(await KD.confirm({ title: "Sign out without saving?", body: "<p>Your profile changes haven't been saved.</p>", confirm: "Sign out" }))) return;
      KD.signingOut = true;
      try { await firebase.auth().signOut(); } catch (e) { /* the redirect still ends the session view */ }
      try { localStorage.setItem("isSignedIn", "false"); } catch (e) { /* ignore */ }
      location.href = KD.SITE + "/";
    });
    KD.$("[data-delete-account]", root).addEventListener("click", async function () {
      var ok = await KD.confirm({
        title: "Delete your account?",
        body: "<p>This permanently deletes your account and <b>all of your data</b>:</p>" +
          '<ul class="stack" style="gap:6px;margin:0;padding-left:18px;font-size:14px;color:var(--ink-2)">' +
            "<li>Every deck you've built or published (public decks leave the gallery)</li>" +
            "<li>Your card collection and binders</li>" +
            "<li>Your Arena match history and coach data</li>" +
            "<li>Your posts, comments, likes, followers and follows</li>" +
            "<li>Your Kraken Pro subscription, cancelled immediately with no refund for the current period</li>" +
          "</ul><p><b>This can't be undone.</b></p>",
        confirm: "Delete everything", danger: true, typeToConfirm: "DELETE"
      });
      if (!ok) return;
      KD.busy("Deleting your account. This can take a minute…");
      try {
        var r = await D.callFn("deleteMyAccount", { confirm: "DELETE" });
        if (r.ok && r.data.ok) {
          KD.signingOut = true;
          await firebase.auth().signOut().catch(function () {});
          try { localStorage.setItem("isSignedIn", "false"); } catch (e) { /* ignore */ }
          location.href = KD.SITE + "/";
          return;
        }
        KD.idle();
        KD.toast(r.data.error || "Deletion failed. Please try again.", "err");
      } catch (e) { console.error(e); KD.idle(); KD.toast("Deletion failed. Please try again.", "err"); }
    });
  };

  function linkField(name, icon, label, value) {
    return '<label class="field"><span class="label">' + esc(label) + "</span>" +
      '<span class="inputwrap">' + KD.icon(icon) + '<input class="input" name="' + name + '" inputmode="url" autocomplete="url" spellcheck="false" value="' + esc(value || "") + '" placeholder="https://"></span></label>';
  }
})();
